export default __webpack_public_path__ + "static/media/pause.548706cb.svg";